__turbopack_context__.v({
  "banner-fade-in": "PromoBadge-module-scss-module__1GMtvW__banner-fade-in",
  "banner-slide-down": "PromoBadge-module-scss-module__1GMtvW__banner-slide-down",
  "blue_gray": "PromoBadge-module-scss-module__1GMtvW__blue_gray",
  "ctmred": "PromoBadge-module-scss-module__1GMtvW__ctmred",
  "grantchester_olive": "PromoBadge-module-scss-module__1GMtvW__grantchester_olive",
  "half": "PromoBadge-module-scss-module__1GMtvW__half",
  "heart_icon": "PromoBadge-module-scss-module__1GMtvW__heart_icon",
  "light_blue": "PromoBadge-module-scss-module__1GMtvW__light_blue",
  "marble_hall_brown": "PromoBadge-module-scss-module__1GMtvW__marble_hall_brown",
  "marlow_blue": "PromoBadge-module-scss-module__1GMtvW__marlow_blue",
  "next_icon": "PromoBadge-module-scss-module__1GMtvW__next_icon",
  "passport_lockup": "PromoBadge-module-scss-module__1GMtvW__passport_lockup",
  "pmgd_logo": "PromoBadge-module-scss-module__1GMtvW__pmgd_logo",
  "promo_badge": "PromoBadge-module-scss-module__1GMtvW__promo_badge",
  "promo_badge__close_button": "PromoBadge-module-scss-module__1GMtvW__promo_badge__close_button",
  "promo_badge__cta": "PromoBadge-module-scss-module__1GMtvW__promo_badge__cta",
  "promo_badge__headline": "PromoBadge-module-scss-module__1GMtvW__promo_badge__headline",
  "promo_badge__shop_icon_link": "PromoBadge-module-scss-module__1GMtvW__promo_badge__shop_icon_link",
  "promo_badge__show_logo": "PromoBadge-module-scss-module__1GMtvW__promo_badge__show_logo",
  "promo_badge__show_logo_desktop": "PromoBadge-module-scss-module__1GMtvW__promo_badge__show_logo_desktop",
  "promo_badge__show_logo_mobile": "PromoBadge-module-scss-module__1GMtvW__promo_badge__show_logo_mobile",
  "promo_badge__wrapper": "PromoBadge-module-scss-module__1GMtvW__promo_badge__wrapper",
  "quarter": "PromoBadge-module-scss-module__1GMtvW__quarter",
  "red": "PromoBadge-module-scss-module__1GMtvW__red",
  "teal": "PromoBadge-module-scss-module__1GMtvW__teal",
  "yellow": "PromoBadge-module-scss-module__1GMtvW__yellow",
});
